import { React, useEffect } from 'react';
import Tab from './tabs';

function adminUNIKAL() {
  return (
    <div className="admin-page">
        <body>
            <Tab/>
      </body>
      {/* <footer> EDAP-UNILIS © All Rights Reserved.</footer> */}
    </div>
  );
}

export default adminUNIKAL;
